module.exports = __webpack_public_path__ + "static/media/icon-airport-tower-grey.3817a045.svg";